import logo from "../../images/logo.png";

export default function Preloader() {
  return (
    <div className="preloader">
      <div className="preloader-content">
        <img
          src={logo}
          alt="logo"
          className="preloader-logo"
        />
      </div>
    </div>
  );
}